export default "__VITE_ASSET__CcWyKSGU__"